// extracted by mini-css-extract-plugin
export default {"skillsList":"SkillsList_skillsList__Hdhx0"};